<!--
 * @Description: 收益人
 * @Date: 2025-05-20 18:02:01
-->
<template>
  <div class="account-info__items account-info__multiple">
    <BaseTextTitle class="account-info__items__title">
      <span style="margin-right: 35px">收益人信息</span>
      <template v-if="!disabled">
        <BaseButton :disabled="addDisabled" @click="onAdd">新增</BaseButton>
        <span style="font-size: 14px; color: red">
          1.请填写实际收益比例超过25%的受益人；2.最少填写1组，最多填写4组股东信息
        </span>
      </template>
    </BaseTextTitle>
    <BaseTextContent
      v-for="(item, index) in formData.fyBeneficiaryInfoList"
      :key="index + '_' + Date.now()"
      class="account-info__content"
    >
      <BaseButton
        class="account-info__multiple__delete"
        v-if="index && !disabled"
        @click="onDelete(index)"
      >
        删除
      </BaseButton>
      <BaseFormItem
        label="姓名"
        :prop="defProp(index, 'name')"
        :rules="[
          {
            required: true,
            trigger: 'change',
            message: '请输入'
          }
        ]"
      >
        <BaseInput
          style="width: 100%"
          type="text"
          placeholder="请输入"
          v-model="item.name"
        ></BaseInput>
      </BaseFormItem>
      <BaseFormItem
        label="证件类型"
        :prop="defProp(index, 'certTp')"
        :rules="[
          {
            required: true,
            trigger: 'change',
            message: '请选择'
          }
        ]"
      >
        <BaseSelect
          placeholder="请选择"
          :options="CERT_TP_OPTIONS"
          v-model="item.certTp"
        ></BaseSelect>
      </BaseFormItem>
      <BaseFormItem
        label="手机号"
        :prop="defProp(index, 'mobile')"
        :rules="[
          {
            required: true,
            trigger: 'change',
            message: '请输入'
          }
        ]"
      >
        <BaseInput
          style="width: 100%"
          type="tel"
          placeholder="请输入"
          clearable
          :maxlength="11"
          v-model="item.mobile"
        ></BaseInput>
      </BaseFormItem>
      <BaseFormItem
        label="证件号"
        :prop="defProp(index, 'certNo')"
        :rules="[
          {
            required: true,
            trigger: 'change',
            message: '请输入'
          }
        ]"
      >
        <BaseInput
          style="width: 100%"
          type="text"
          placeholder="请输入"
          inputTextReplace
          :inputTexts="['英文字母', '数字']"
          v-model="item.certNo"
        ></BaseInput>
      </BaseFormItem>
      <BaseFormItem
        label="地址"
        :prop="defProp(index, 'address')"
        :rules="[
          {
            required: true,
            trigger: 'change',
            message: '请输入'
          }
        ]"
      >
        <BaseInput
          style="width: 100%"
          type="text"
          placeholder="请输入"
          v-model="item.address"
        ></BaseInput>
      </BaseFormItem>
      <BaseFormItem
        label="收益方式"
        :prop="defProp(index, 'beneficiaryType')"
        :rules="[
          {
            required: true,
            trigger: 'change',
            message: '请选择'
          }
        ]"
      >
        <BaseSelect
          placeholder="请选择"
          :options="BENEFICIARY_TYPE_OPTIONS"
          v-model="item.beneficiaryType"
        ></BaseSelect>
      </BaseFormItem>
      <BizFormTimes
        class="account-info__block"
        label="证件有效期"
        :startProp="defProp(index, 'validDateStart')"
        :endProp="defProp(index, 'validDateEnd')"
        v-model:start="formData.fyBeneficiaryInfoList[index].validDateStart"
        v-model:end="formData.fyBeneficiaryInfoList[index].validDateEnd"
      />

      <BaseFormItem
        style="grid-column-start: 1; grid-column-end: 3"
        label="身份证照片（人像面）"
        :prop="defProp(index, 'portraitFilePath')"
        :rules="[
          {
            required: true,
            trigger: 'change',
            message: '请上传'
          }
        ]"
      >
        <BaseUpload
          style="width: 100%"
          ref="portraitFilePathRef"
          listType="picture-card"
          :disabled="disabled"
          :accept="['.jpg', '.jpeg', '.png', '.JPG', '.JPEG', '.PNG']"
          :drag="false"
          :limit="1"
          :limitSize="5"
          :multiple="false"
          :auto-upload="true"
          :onError="onUploadErr"
          :http-request="uploadApi"
          :beforeRemove="
            (file, remove) => {
              remove();
              onUploadRemove('fyBeneficiaryInfoList.portraitFilePath', index);
              return true;
            }
          "
          v-model:fileList="uploadModelMap[defProp(index, 'portraitFilePath')]"
          @change="
            v =>
              onUploadChange(v, 'fyBeneficiaryInfoList.portraitFilePath', index)
          "
        >
          <template #tip>
            <span class="enterprise-real-form-upload">
              请上传证件的彩色扫描件或照片，并确保您上传的图片信息内容清晰、可辨，单个文件大小不超过
              5M；
            </span>
          </template>
        </BaseUpload>
      </BaseFormItem>
      <BaseFormItem
        style="grid-column-start: 3; grid-column-end: 5"
        label="身份证照片（国徽面）"
        :prop="defProp(index, 'badgeFilePath')"
        :rules="[
          {
            required: true,
            trigger: 'change',
            message: '请上传'
          }
        ]"
      >
        <BaseUpload
          style="width: 100%"
          ref="badgeFilePathRef"
          listType="picture-card"
          :disabled="disabled"
          :accept="['.jpg', '.jpeg', '.png', '.JPG', '.JPEG', '.PNG']"
          :drag="false"
          :limit="1"
          :limitSize="5"
          :multiple="false"
          :auto-upload="true"
          :onError="onUploadErr"
          :http-request="uploadApi"
          :beforeRemove="
            (file, remove) => {
              remove();
              onUploadRemove('fyBeneficiaryInfoList.badgeFilePath', index);
              return true;
            }
          "
          v-model:fileList="uploadModelMap[defProp(index, 'badgeFilePath')]"
          @change="
            v => onUploadChange(v, 'fyBeneficiaryInfoList.badgeFilePath', index)
          "
        >
          <template #tip>
            <span class="enterprise-real-form-upload">
              请上传证件的彩色扫描件或照片，并确保您上传的图片信息内容清晰、可辨，单个文件大小不超过
              5M；
            </span>
          </template>
        </BaseUpload>
      </BaseFormItem>
    </BaseTextContent>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import {
  BaseFormItem,
  BaseInput,
  BaseUpload,
  BaseSelect,
  BaseTextContent,
  BaseTextTitle,
  BaseButton
} from 'xrk-components';
import { storeToRefs } from 'pinia';
import infoStore from '../../store/info';
import { uploadApi } from '@/common/data-source/common/apis';
import { useUpload } from '../../hooks';
import BizFormTimes from '@/components/biz/biz-form-times';

const CERT_TP_OPTIONS = [
  { label: '身份证', value: '0' },
  { label: '外国护照', value: '1' }
];
const BENEFICIARY_TYPE_OPTIONS = [
  { label: '股权', value: '01' },
  { label: '表决权', value: '02' },
  { label: '高级管理员人员', value: '03' },
  { label: '其他', value: '04' }
];

const { formData, formRef, disabled } = storeToRefs(infoStore());
const { uploadModelMap, onUploadErr, onUploadRemove, onUploadChange } =
  useUpload(formData, formRef, [
    'fyBeneficiaryInfoList.portraitFilePath',
    'fyBeneficiaryInfoList.badgeFilePath'
  ]);

const addDisabled = computed(() => {
  return formData.value.fyBeneficiaryInfoList.length >= 4 || disabled.value;
});

const defProp = (index, key) => {
  return `fyBeneficiaryInfoList.${index}.${key}`;
};

const onAdd = () => {
  if (addDisabled.value) return;
  formData.value.fyBeneficiaryInfoList.push({
    name: '',
    certTp: '0',
    certNo: '',
    validDateStart: '',
    validDateEnd: '',
    mobile: '',
    address: '',
    portraitFilePath: '',
    badgeFilePath: '',
    beneficiaryType: null
  });
};
const onDelete = index => {
  if (!index) return;
  formData.value.fyBeneficiaryInfoList.splice(index, 1);
};
</script>
